import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const errorsNotFoundRoute: InvariantJiraRoute = {
	name: 'errors-not-found',
	path: '/jira/:projectType(software|servicedesk|core)',
};
